import { useTheme } from '@emotion/react';
import Head from 'next/head';
import { sanitizeGoogleFontName } from 'utils/font';

export const WhiteLabelGoogleFontLoader: React.FC = () => {
  const theme = useTheme();
  const raw = theme.whiteLabelTheme?.googleFont;
  const googleFont = raw ? sanitizeGoogleFontName(raw) : null;

  if (!googleFont) return null;

  const fontUrl = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(
    googleFont
  )}:wght@300;400;600&display=swap`;

  return (
    <Head>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link
        rel="preconnect"
        href="https://fonts.gstatic.com"
        crossOrigin="anonymous"
      />
      <link href={fontUrl} rel="stylesheet" />
    </Head>
  );
};
